module.exports = __webpack_public_path__ + "img/twitter-x.faae6502.svg";